// "New results" badge state — client-side v1 (localStorage, per-uid).
//
// Tracks when the user last viewed Results. The nav shows a dot when a pick has
// resolved since then (max resolvedAt > lastViewed). Keyed by uid so an
// anonymous per-browser session is correct. For SECURED accounts AppShell now
// reconciles this local value with the server-written
// users/{uid}.lastResultsViewedAt (max of the two) so a result viewed on one
// device clears the badge on another (audit B9); anon web users are per-browser
// so localStorage alone is correct for them.

const KEY = (uid) => `ps_resultsLastViewedAt:${uid}`;

/** Millis the user last viewed Results (0 if never). */
export function lastViewedMillis(uid) {
  try {
    const v = window.localStorage.getItem(KEY(uid));
    const n = v ? parseInt(v, 10) : 0;
    return Number.isFinite(n) ? n : 0;
  } catch {
    return 0;
  }
}

/** Stamp "viewed now" — clears the badge. */
export function markResultsViewed(uid) {
  try {
    window.localStorage.setItem(KEY(uid), String(Date.now()));
  } catch {
    /* localStorage unavailable (private mode quota) — badge just won't persist */
  }
}
